module.exports = __webpack_public_path__ + "img/product-7-mobileINTguanhuai.f6e4a544.png";